import React, { useContext, useEffect, useRef, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import { FormActions } from "./styled";
import DashboardCardWrapper from "components/Dashboard/Cards/Wrapper";
import DashboardActions from "components/Dashboard/Actions";
import DashboardFormsCore from "../Core";
import { Create, ReadOne, Update, Read } from "services/event";
import { exposeStrapiError } from "utils";
import { toast } from "react-toastify";
import { CoreContext } from "context/CoreContext";

export const booleanOptions = [
  { id: "true", title: "Sim" },
  { id: "false", title: "Não" },
];

export default function DashboardFormsEvent() {
  const history = useHistory();
  const { id } = useParams();
  const { currentCompany } = useContext(CoreContext);
  const refForm = useRef();

  const actions = [
    { title: "Cancelar", outline: true, action: () => history.goBack() },
    { title: "Salvar", action: () => save(), loadable: true },
  ];

  const [loading, setLoading] = useState(false);
  const [register, setRegister] = useState(null);
  const [saving, setSaving] = useState(false);

  const [formItems, setFormItems] = useState([
    { placeholder: "Código", ref: "code", half: true, disabled: true },
    { placeholder: "Evento", ref: "name", half: true, disabled: true },
    {
      placeholder: "Mostrar no Dashboard",
      ref: "is_dashboard",
      options: booleanOptions,
    },
  ]);

  useEffect(() => {
    if (id) {
      setLoading(true);
      ReadOne(id)
        .then((result) => {
          if (result?.data?.id) {
            setRegister({
              ...result.data.attributes,
              is_dashboard: result.data.attributes.is_dashboard
                ? "true"
                : "false",
              sheetType: result.data.attributes.sheetType,
            });
          }
        })
        .catch(() => toast.error("Erro ao carregar evento"))
        .finally(() => setLoading(false));
    }
  }, [id]);

  const save = async () => {
    const payload = {
      ...refForm.current.getForm(),
      company: currentCompany?.id,
    };

    if (Object.values(payload).some((value) => !value)) {
      toast.error("Preencha todos os campos");
      return;
    }

    // Obtendo eventos ativos no dashboard
    setSaving(true);
    try {
      const response = await Read(currentCompany?.id, register.sheetType);
      if (response?.data) {
        const activeEvents = response.data.filter(
          (event) => event.attributes.is_dashboard
        );

        if (payload.is_dashboard === "true" && activeEvents.length >= 6) {
          toast.error(
            "Limite de 6 eventos ativos no dashboard atingido. Desative um evento para ativar este."
          );
          setSaving(false);
          history.goBack();
        } else {
          const result = id
            ? await Update({ data: payload }, id)
            : await Create({ data: payload });

          if (result && !exposeStrapiError(result)) {
            toast.success("Evento salvo com sucesso!");
            history.goBack();
          } else {
            toast.error("Erro ao salvar, tente novamente mais tarde");
          }
        }
      }
    } catch (error) {
      toast.error("Erro ao verificar eventos ativos.");
    }

    setSaving(false);
  };

  return (
    <DashboardCardWrapper backable title={"Cadastro de evento"} white>
      <DashboardFormsCore
        formItems={formItems}
        register={register}
        ref={refForm}
      />
      <FormActions>
        <DashboardActions actions={actions} loading={saving} />
      </FormActions>
    </DashboardCardWrapper>
  );
}
